module.exports = __webpack_public_path__ + "img/menu_banner.3c07eace.jpg";